import { Button, HStack, Text, VStack } from "native-base";
import React, { useState } from "react";

import FormButton from "@/components/atoms/FormButton";

import { AppEvaluationData, OrdeEvaluationComponentProps } from "../types";

const AppEvaluationStep = ({
  isSubmiting,
  onSubmit,
  onCancel,
}: OrdeEvaluationComponentProps<AppEvaluationData> & { isSubmiting: boolean }) => {
  const [rating, setRating] = useState(null);

  return (
    <VStack>
      <VStack my="2" space={2} alignItems="center">
        <Text fontSize="lg" color="primary.600">
          Você também pode avaliar o iFeira
        </Text>
        <Text color="gray.400" textAlign="center">
          De 0 a 10, qual a change de indicar o iFeira para um amigo?
        </Text>
      </VStack>
      <HStack my="6" justifyContent="center" flexWrap="wrap">
        {Array(10)
          .fill(Number)
          .map((_, i) => (
            <Button
              key={"rating-" + i + rating}
              w="64px"
              h="64px"
              margin="1"
              rounded="full"
              variant="outline"
              bg={rating === i ? "secondary.400" : "white"}
              _text={{
                fontSize: 22,
              }}
              onPress={() => setRating(i)}>
              {i + 1}
            </Button>
          ))}
      </HStack>
      <HStack my="6" justifyContent="space-between">
        <FormButton
          width="40%"
          colorScheme="white"
          textColor="primary.700"
          shadow="2"
          onPress={() => onCancel()}>
          Voltar
        </FormButton>
        <FormButton
          isDisabled={rating === null}
          isLoading={isSubmiting}
          width="40%"
          onPress={() =>
            onSubmit({
              rate: rating,
            })
          }>
          Finalizar
        </FormButton>
      </HStack>
    </VStack>
  );
};

export default AppEvaluationStep;
